// Maker Embed Script
(function() {
    // Geo placeholders replaced by the CF Worker proxy before the script reaches the browser.
    // Falls back to empty strings when served directly from CDN (e.g. local dev).
    window.__mkrLocale = window.__mkrLocale || { country: '__CF_COUNTRY__', city: '__CF_CITY__', region: '__CF_REGION__', regionCode: '__CF_REGION_CODE__' };

    function decodeMockGeoParam(search) {
        const param = new URLSearchParams(search).get('mkr_geo');
        if (!param) return null;
        try {
            // A raw "+" in a hand-built base64 query value decodes to a space under
            // form-urlencoded rules; undo that before atob (space is never valid base64).
            return JSON.parse(atob(param.replace(/ /g, '+')));
        } catch (e) {
            return null;
        }
    }

    function applyMockGeo() {
        const mock = window.__mkrGeoMockOverride || decodeMockGeoParam(window.location.search);
        if (!mock) return;
        window.__mkrLocale = {
            country: mock.country || window.__mkrLocale.country,
            city: mock.city || window.__mkrLocale.city,
            region: mock.region || window.__mkrLocale.region,
            regionCode: mock.regionCode || window.__mkrLocale.regionCode,
        };
    }
    applyMockGeo();

    

    // document.currentScript is only valid during this initial synchronous
    // execution; capture everything derived from it before any deferral
    // (createContainer may wait for DOMContentLoaded).
    const scriptElement = document.currentScript;
    const baseUrl = scriptElement && scriptElement.src ? scriptElement.src.split('/embed.js')[0] : '';
    const loadTs = scriptElement && scriptElement.getAttribute('data-mkr-load-ts');

    function buildContainerEl() {
        const container = document.createElement('div');
        container.id = 'cms7t34cx0051u00ze847wbc1-root';
        container.className = 'cms7t34cx0051u00ze847wbc1-app makerai-app';
        return container;
    }

    function tryMountContainer(scriptEl) {
        const existing = document.getElementById('cms7t34cx0051u00ze847wbc1-root');
        if (existing) {
            // The documented copy-paste snippet ships this div bare (no
            // class) — every rule in main.css is scoped behind
            // .cms7t34cx0051u00ze847wbc1-app, so without this the app renders unstyled.
            existing.classList.add('cms7t34cx0051u00ze847wbc1-app', 'makerai-app');
            return existing;
        }
        const targetId = scriptEl && scriptEl.getAttribute('data-target-id');
        if (targetId) {
            const target = document.getElementById(targetId);
            if (target) {
                const container = buildContainerEl();
                target.appendChild(container);
                return container;
            }
        }
        return null;
    }

    function mountFallbackContainer(scriptEl) {
        const targetId = scriptEl && scriptEl.getAttribute('data-target-id');
        if (targetId) {
            console.warn('[maker-embed] data-target-id "' + targetId + '" not found in DOM, falling back to default placement.');
        }
        const container = buildContainerEl();
        if (scriptEl && scriptEl.parentNode && scriptEl.parentNode !== document.head) {
            scriptEl.parentNode.insertBefore(container, scriptEl);
        } else {
            // Org-embed default rules inject this script into <head> on
            // purpose (data-mkr-org-project set) — the root-div advice only
            // applies to hand-pasted snippets.
            if (!scriptEl || !scriptEl.hasAttribute('data-mkr-org-project')) {
                console.warn('[maker-embed] No #cms7t34cx0051u00ze847wbc1-root element found. Add <div id="cms7t34cx0051u00ze847wbc1-root"></div> where the app should render; appending to <body> instead.');
            }
            document.body.appendChild(container);
        }
        return container;
    }

    function createContainer(scriptEl) {
        return new Promise(function(resolve) {
            const mounted = tryMountContainer(scriptEl);
            if (mounted) { resolve(mounted); return; }
            if (document.readyState === 'loading') {
                // documentElement, not body: body is null while the parser is
                // still inside <head>.
                let settled = false;
                const observer = new MutationObserver(function() {
                    if (settled) return;
                    const el = tryMountContainer(scriptEl);
                    if (el) { settled = true; observer.disconnect(); resolve(el); }
                });
                observer.observe(document.documentElement, { childList: true, subtree: true });
                document.addEventListener('DOMContentLoaded', function() {
                    if (settled) return;
                    settled = true;
                    observer.disconnect();
                    const retry = tryMountContainer(scriptEl);
                    resolve(retry || mountFallbackContainer(scriptEl));
                }, { once: true });
                return;
            }
            resolve(mountFallbackContainer(scriptEl));
        });
    }


    function addMadeWithMakerLink(container) {
     return new Promise((resolve, reject) => {
        const link = document.createElement('a');
        link.href = 'https://ai.maker.co';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.position = 'sticky';
        link.style.bottom = '8px';
        link.style.right = '8px';
        link.style.left = '8px';
        link.style.textDecoration = 'none';
        link.style.zIndex = '9999';
        link.style.display = 'block';
        link.style.height = '24px';
        link.style.width = 'fit-content';
        link.style.lineHeight = '24px';
        link.style.padding = '0 8px';
        link.style.borderRadius = '6px';
        link.style.backgroundColor = 'rgba(0, 0, 0, 0.60)';
        link.style.backdropFilter = 'blur(2px)';
        link.style.color = '#FFF';
        link.style.fontFamily = 'sans-serif';
        link.style.fontSize = '12px';
        link.style.fontWeight = '500';
        link.textContent = 'Made with maker';
        container.appendChild(link);
        resolve();
      });
    }


    function loadCSS(href) {
        return new Promise(function(resolve) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.setAttribute('fetchpriority', 'high');
            link.href = href;
            link.onload = resolve;
            link.onerror = resolve;
            document.head.appendChild(link);
        });
    }

    function loadScript(src, external, is_async, attrs) {
        return new Promise(function(resolve, reject) {
            const script = document.createElement('script');
            script.type = external ? 'text/javascript' : 'module';
            script.setAttribute('fetchpriority', 'high');
            Object.entries(attrs || {}).forEach(function(entry) {
                script.setAttribute(entry[0], entry[1]);
            });
            script.src = src;
            if (is_async) script.async = true;
            script.onload = resolve;
            script.onerror = reject;
            (external ? document.head : document.body).appendChild(script);
        });
    }

    function loadInlineScripts(type, scriptContent, tagName) {
        return new Promise(function(resolve, reject) {
            try {
                const script = document.createElement(tagName);
                if (tagName == 'script') script.type = type;
                script.textContent = scriptContent;
                document.body.appendChild(script);
                resolve();
            } catch (e) {
                reject(e);
            }
        });
    }


    async function init() {
        try {
            // CSS only touches <head>; start it while the container mount may
            // still be waiting for the target to be parsed.
            const cssReady = loadCSS(baseUrl + '/assets/main.css');

            // loadTs makes the ES module registry treat each SPA re-injection
            // as a distinct URL so main.js re-executes (A -> B -> A fix).
            const mainSrc = baseUrl + '/assets/main.js' + (loadTs ? '?_r=' + loadTs : '');

            // The module <script> can only be appended once the body exists,
            // but its download can start now — same-document preload match,
            // so the later loadScript reuses the response instead of
            // serializing behind the container mount.
            const warmMain = document.createElement('link');
            warmMain.rel = 'modulepreload';
            warmMain.href = mainSrc;
            document.head.appendChild(warmMain);

            // Everything below appends to <body>; createContainer resolving
            // guarantees the body exists.
            const container = await createContainer(scriptElement);

            const posthogReady = loadInlineScripts("text/javascript", "\n(function() {\n  // PostHog SDK stub — init is deferred until consent is confirmed.\n  !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(\".\");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement(\"script\")).type=\"text/javascript\",p.crossOrigin=\"anonymous\",p.async=!0,p.src=s.api_host.replace(\".i.posthog.com\",\"-assets.i.posthog.com\")+\"/static/array.js\",(r=t.getElementsByTagName(\"script\")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a=\"posthog\",u.people=u.people||[],u.toString=function(t){var e=\"posthog\";return\"posthog\"!==a&&(e+=\".\"+a),t||(e+=\" (stub)\"),e},u.people.toString=function(){return u.toString(1)+\".people (stub)\"},o=\"Ir Sr init jr $r Ci qr Hr Dr capture calculateEventProperties Wr register register_once register_for_session unregister unregister_for_session Qr getFeatureFlag getFeatureFlagPayload getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync tn identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty Jr Yr createPersonProfile setInternalOrTestUser Kr Pr nn opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing zr debug ki Xr getPageViewId captureTraceFeedback captureTraceMetric Mr\".split(\" \"),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);\n\n  var _mkrPhToken = 'phc_qbDTSuJCBxyX8CACLOEhPNZBvJVcELuLXGG6J2ibUmK';\n  var _mkrPhConfig = {\n    api_host: 'https://athena.maker.co',\n    ui_host: 'https://us.posthog.com',\n    defaults: '2026-01-30',\n    person_profiles: 'identified_only',\n    name: 'ph_devi_cms7t34cx0051u00ze847wbc1',\n    autocapture: { css_selector_allowlist: ['[data-tracking-id]'] },\n    disable_surveys: true,\n    capture_dead_clicks: false,\n    loaded: function(posthog) {\n      posthog.register({\n        mkr_product: 'devi',\n        mkr_project_id: 'cms7t34cx0051u00ze847wbc1',\n        mkr_org_id: 'org_2RBv1h4UPjxgiWMqB0pn9NmpxH9',\n        mkr_organization_name: 'unknown',\n        mkr_version: 1785749274641,\n        mkr_host_domain: window.__mkr_host_domain || window.location.hostname,\n        mkr_host_url: window.__mkr_host_url || window.location.href\n      });\n      \n  var _instanceName = 'ph_devi_cms7t34cx0051u00ze847wbc1';\n  window.__mkr_ph = window.__mkr_ph || {};\n  window.__mkr_ph[_instanceName] = { distinctId: posthog.get_distinct_id(), buckets: {} };\n  document.dispatchEvent(new CustomEvent('mkr:ph:ready', { detail: { instanceName: _instanceName, distinctId: window.__mkr_ph[_instanceName].distinctId } }));\n\n    },\n  };\n\n  var _mkrPhInited = false;\n  var syncPostHogToConsent = function(allowed) {\n    if (!allowed) {\n      if (_mkrPhInited) posthog.opt_out_capturing();\n      return;\n    }\n    if (_mkrPhInited) {\n      posthog.opt_in_capturing();\n    } else {\n      _mkrPhInited = true;\n      posthog.init(_mkrPhToken, _mkrPhConfig);\n    }\n  };\n\n  // Only an explicit analytics === 'no' from the Shopify CMP denies.\n  var readShopifyConsent = function() {\n    try {\n      var c = window.Shopify.customerPrivacy.currentVisitorConsent();\n      return c.analytics !== 'no';\n    } catch(e) { return true; }\n  };\n  var isConsentResolved = function() {\n    try {\n      var c = window.Shopify.customerPrivacy.currentVisitorConsent();\n      return c.analytics === 'yes' || c.analytics === 'no';\n    } catch(e) { return false; }\n  };\n\n  // Poll Shopify CMP every 100 ms; fail-open after 3 s (handles US stores with no banner).\n  var startShopifyConsentPolling = function() {\n    var start = Date.now(), resolved = false;\n    var interval = setInterval(function() {\n      if (resolved) return;\n      if (!isConsentResolved() && Date.now() - start < 3000) return;\n      clearInterval(interval);\n      resolved = true;\n      syncPostHogToConsent(readShopifyConsent());\n    }, 100);\n    document.addEventListener('visitorConsentCollected', function() {\n      if (!resolved) { clearInterval(interval); resolved = true; }\n      syncPostHogToConsent(readShopifyConsent());\n    });\n  };\n\n  if (window.parent !== window) {\n    // Iframe embed branch — consent signals forwarded by the parent loader via window vars\n    // and postMessage. window.__mkr_shopify_cmp / __mkr_gpc / __mkr_accept_cookies are\n    // injected into the srcdoc by iframe.ts before embed.js loads.\n    if (window.__mkr_gpc) {\n      // GPC forwarded from parent — deny, don't init.\n    } else if (!window.__mkr_accept_cookies) {\n      // Explicit acceptCookies=false forwarded from parent — deny.\n    } else if (!window.__mkr_shopify_cmp) {\n      // No Shopify CMP on the parent page — allow.\n      syncPostHogToConsent(true);\n    } else {\n      // Shopify CMP detected on parent — default-deny, wait for consent postMessage.\n      // Attach listener before posting ready so no message is missed.\n      var _mkrIframeConsentReceived = false;\n      var _mkrIframeFailOpen = setTimeout(function() {\n        if (!_mkrIframeConsentReceived) {\n          _mkrIframeConsentReceived = true;\n          syncPostHogToConsent(true);\n        }\n      }, 3000);\n      window.addEventListener('message', function(e) {\n        if (!e.data || e.data.type !== 'mkr_tracking_consent') return;\n        if (!_mkrIframeConsentReceived) {\n          clearTimeout(_mkrIframeFailOpen);\n          _mkrIframeConsentReceived = true;\n        }\n        syncPostHogToConsent(e.data.allowed);\n      });\n      // Tell the parent this listener is ready so it can flush any buffered consent.\n      window.parent.postMessage({ type: 'mkr_iframe_consent_ready' }, '*');\n    }\n  } else {\n    // Top-frame branch — simple and org embeds running directly on the customer's page.\n    if (navigator.globalPrivacyControl === true) {\n      // GPC: first-class deny signal, no init.\n    } else if (window.acceptCookies === false) {\n      // Explicit acceptCookies=false deny — checked before Shopify CMP so it always wins.\n    } else if (!window.Shopify || typeof window.Shopify !== 'object') {\n      // Non-Shopify site (or null window.Shopify): no explicit deny → allow.\n      syncPostHogToConsent(true);\n    } else {\n      // Shopify store: auto-detect CMP, poll for consent, subscribe to runtime changes.\n      startShopifyConsentPolling();\n    }\n  }\n})();\n  ", "script");

            const mainReady = loadScript(mainSrc, false, true);

            await Promise.all([cssReady, mainReady]);
            
            await posthogReady;
            
            
            // Trigger DOMContentLoaded so main.jsx's handler finds the container.
            document.dispatchEvent(new Event('DOMContentLoaded'));
        } catch (error) {
            console.error('Failed to load maker widget:', error);
        }
    }

    init();

})();